import React, { Component } from "react";
import Headers from "../Layouts/Headers";
import axios from "axios";
import $ from "jquery";
import { TriageSidebar } from "../Layouts/TriageSidebar";
import { Preview, print } from "react-html2pdf";

export class MenstrualHistory extends Component {
  constructor(props) {
    super(props);

   

    const url = "";

    this.state = {
      chiefComplaint: "chiefComplaint",
      AgeOfMenarche: "",
      LMP: "",
      EDD: "",
      GestationalAge: "",
      CycleRegular: "",
      Duration: "",
      Quantity: "",
      AssociationPain: "",
      patientName: localStorage.getItem("currentVisitName"),
      loading : false

      // 				visitid = request.headers["visitid"],
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.PrintWindow = this.PrintWindow.bind(this);
    //this.PrintWindow = this.PrintWindow.bind(this);
  }

  componentDidMount() {}

  proceedEvent(event) {
    window.location.href = "/previous/obstetrics/history";
  }

  handleChange(event) {
    this.setState({ [event.target.name]: event.target.value });
  }

  PrintWindow(event) {
    document.title =
      localStorage.getItem("currentVisitName") + "`s " + this.constructor.name;
    $(".modal").hide();
    window.print();
  }

  handleSubmit = (event) => {
    const headers = {
      "Content-Type": "application/json",
      token: localStorage.getItem("accessToken"),
      visitid: localStorage.getItem("currentVisitId"),
    };
    event.preventDefault();
    this.setState({
      loading: true
    })
    axios
      .post(
        this.api_url+""+localStorage.getItem('currentModule')+"/menstrualhistory/main",
        this.state,
        { headers: headers }
      )
      .then((response) => {
        console.log(response);
        this.setState({
          loading: false
        })
        if (response.data["status"]) {
          $(".alert-success").show();

          setTimeout(function () {
            $(".HistoryModal").show();
          }, 1500);
        }
      })
      .catch((error) => {
        console.log(error);
        $('#SubmitError').show();
        $(".alert-success").hide();
      });
  };
  render() {
    const font16 = { fontSize: "16px" };
    const fontFamilyNunito = { fontFamily: "Nunito, sans-serif" };
    const floatRight = { float: "right;" };
    const floatLeft = { float: "left;" };
    const displayHidden = { display: "none" };
    const width100 = { width: "100%" };
    const autoscroll = { overflowY: "auto" };

    const {
      chiefComplaint,
      AgeOfMenarche,
      LMP,
      EDD,
      GestationalAge,
      CycleRegular,
      Duration,
      Quantity,
      AssociationPain,
      patientName,
      loading
    } = this.state;
    return (
      <div>
        <Headers />
        <TriageSidebar />

        <main className="content-container">
          <div className="container p-2">
            <form onSubmit={this.handleSubmit}>
              <div className="col-md-12 font-weight-bold p-1">
                <p className="text-capitalize" style={font16}>
                  Menstrual History
                </p>
              </div>
              <div className="form-row pt-4">
                <div className="col-md-4 p-2">
                  <div className="py-1">
                    <h6 className="text-capitalize" style={fontFamilyNunito}>
                      Age Of Menarche
                    </h6>
                    <input
                      className="form-control"
                      onChange={this.handleChange}
                      value={AgeOfMenarche}
                      name="AgeOfMenarche"
                      type="text"
                      required
                    />
                  </div>
                </div>

                <div className="col-md-4 p-2">
                  <div className="py-1">
                    <h6 className="text-capitalize" style={fontFamilyNunito}>
                      LMP
                    </h6>
                    <input
                      className="form-control"
                      onChange={this.handleChange}
                      value={LMP}
                      name="LMP"
                      type="date"
                      required
                    />
                  </div>
                </div>

                <div className="col-md-4 p-2">
                  <div className="py-1">
                    <h6 className="text-capitalize" style={fontFamilyNunito}>
                      EDD
                    </h6>
                    <input
                      className="form-control"
                      onChange={this.handleChange}
                      value={EDD}
                      name="EDD"
                      type="date"
                      required
                    />
                  </div>
                </div>

                <div className="col-md-4 p-2">
                  <div className="py-1">
                    <h6 className="text-capitalize" style={fontFamilyNunito}>
                      Gestational Age
                    </h6>
                    <input
                      onChange={this.handleChange}
                      value={GestationalAge}
                      name="GestationalAge"
                      className="form-control"
                      type="text"
                      required
                    />
                  </div>
                </div>
              </div>
              <div className="form-row pt-4">
                {/* <div className="col-md-4 text-lg-center font-weight-bold p-1">
                                    <p className="text-capitalize" style={font16}></p>
                                </div> */}
                <div className="col-md-6 p-2">
                  <div className="py-1">
                    <h6 className="text-capitalize" style={fontFamilyNunito}>
                      Cycle Regular
                    </h6>
                    <select
                      className="form-control"
                      onChange={this.handleChange}
                      value={CycleRegular}
                      name="CycleRegular"
                      required
                    >
                      <optgroup label="" className="confirm_card">
                        <option selected disabled></option>
                        <option value="yes">Yes</option>
                        <option value="no">No</option>
                      </optgroup>
                    </select>
                  </div>
                </div>

                <div className="col-md-6 p-2">
                  <div className="py-1">
                    <h6 className="text-capitalize" style={fontFamilyNunito}>
                      Duration
                    </h6>
                    <input
                      className="form-control"
                      onChange={this.handleChange}
                      value={Duration}
                      name="Duration"
                      type="text"
                      required
                    />
                  </div>
                </div>

                <div className="col-md-6 p-2">
                  <div className="py-1">
                    <h6 className="text-capitalize" style={fontFamilyNunito}>
                      Quantity
                    </h6>
                    <input
                      className="form-control"
                      onChange={this.handleChange}
                      value={Quantity}
                      name="Quantity"
                      type="text"
                      required
                    />
                  </div>
                </div>

                <div className="col-md-6 p-2">
                  <div className="py-1">
                    <h6 className="text-capitalize" style={fontFamilyNunito}>
                      Association Pain
                    </h6>
                    <select
                      className="form-control"
                      onChange={this.handleChange}
                      value={AssociationPain}
                      name="AssociationPain"
                      required
                    >
                      <optgroup label="" className="confirm_card">
                        <option selected disabled></option>
                        <option value="yes">Yes</option>
                        <option value="no">No</option>
                      </optgroup>
                    </select>
                  </div>
                </div>
              </div>

              <div
                id="loginSuccess"
                className="alert alert-success"
                style={displayHidden}
                role="alert"
              >
                <strong>Success! </strong>Menstrual History Saved Successfully.
              </div>
              <div
                className="modal HistoryModal"
                style={autoscroll}
                tabIndex="-1"
                role="dialog"
              >
                <div className="modal-dialog" role="document">
                  <div className="modal-content">
                    <div className="modal-header">
                      <h5 className="modal-title">
                        {" "}
                        {patientName}`s Menstrual History Modal
                      </h5>
                      <button
                        type="button"
                        className="close"
                        data-dismiss="modal"
                        aria-label="Close"
                      >
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>
                    <div className="modal-body">
                      {/* <div className="py-1">
                            <h6 className="text-capitalize" style={ fontFamilyNunito }>Name</h6><input className="form-control"   type="text" required/>
                        </div> */}
                      <br />
                      <a
                        className="btn btn-danger proceed"
                        onClick={this.proceedEvent}
                        style={width100}
                      >
                        Proceed to Next
                      </a>
                      <Preview id={"jsx-template"}>
                        <b>NAME: </b>
                        {patientName}

                        <div className="py-1">
                          <h6
                            className="text-capitalize"
                            style={fontFamilyNunito}
                          >
                            Age Of Menarche
                          </h6>
                          <input
                            className="form-control"
                            readOnly
                            value={AgeOfMenarche}
                            name="AgeOfMenarche"
                            type="number"
                            required
                          />
                        </div>

                        <div className="py-1">
                          <h6
                            className="text-capitalize"
                            style={fontFamilyNunito}
                          >
                            LMP
                          </h6>
                          <input
                            className="form-control"
                            readOnly
                            value={LMP}
                            name="LMP"
                            type="date"
                            required
                          />
                        </div>

                        <div className="py-1">
                          <h6
                            className="text-capitalize"
                            style={fontFamilyNunito}
                          >
                            EDD
                          </h6>
                          <input
                            className="form-control"
                            readOnly
                            value={EDD}
                            name="EDD"
                            type="date"
                            required
                          />
                        </div>

                        <div className="py-1">
                          <h6
                            className="text-capitalize"
                            style={fontFamilyNunito}
                          >
                            Gestational Age
                          </h6>
                          <input
                            readOnly
                            value={GestationalAge}
                            name="GestationalAge"
                            className="form-control"
                            type="number"
                            required
                          />
                        </div>
                        <div className="py-1">
                          <h6
                            className="text-capitalize"
                            style={fontFamilyNunito}
                          >
                            Cycle Regular
                          </h6>
                          <input
                            className="form-control"
                            readOnly
                            value={CycleRegular}
                            name="CycleRegular"
                            required
                          />
                        </div>

                        <div className="py-1">
                          <h6
                            className="text-capitalize"
                            style={fontFamilyNunito}
                          >
                            Duration
                          </h6>
                          <input
                            className="form-control"
                            readOnly
                            value={Duration}
                            name="Duration"
                            type="text"
                            required
                          />
                        </div>

                        <div className="py-1">
                          <h6
                            className="text-capitalize"
                            style={fontFamilyNunito}
                          >
                            Quantity
                          </h6>
                          <input
                            className="form-control"
                            readOnly
                            value={Quantity}
                            name="Quantity"
                            type="number"
                            required
                          />
                        </div>

                        <div className="py-1">
                          <h6
                            className="text-capitalize"
                            style={fontFamilyNunito}
                          >
                            Association Pain
                          </h6>
                          <input
                            className="form-control"
                            readOnly
                            value={AssociationPain}
                            name="AssociationPain"
                            required
                          />
                        </div>
                      </Preview>
                    </div>
                  </div>
                </div>
              </div>
              <div
                className="alert alert-danger"
                id="SubmitError"
                style={displayHidden}
                role="alert"
              >
                <strong> </strong>Something went wrong. Please try again
              </div>
              <div
                id="SubmitSuccess"
                className="alert alert-success"
                style={displayHidden}
                role="alert"
              >
                <strong>Success! </strong>Details were saved Successfuly.
              </div>
              <div className="row">
                {/* <div style={displayHidden} className="col col-6"><button className="btn btn-primary btn-warning rounded-pill px-4 font-weight-bold" type="button" style={floatRight}>Send To Triage</button></div> */}
                <div className="col col-6">
                  <button
                    className="btn btn-primary btn-warning rounded-pill px-5 font-weight-bold"
                    type="submit"
                    style={floatLeft}
                  >
                  {loading ? 'Loading' : 'Submit'}  
                  </button>
                </div>
              </div>
            </form>
          </div>
        </main>
      </div>
    );
  }
}

export default MenstrualHistory;
